export default __webpack_public_path__ + "resources/icons/d212-b137.png";